import Sidebar from '../components/sidebar';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import * as React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import PaymentMethodModal from '../components/modals/payment-method-modal';
import OrderTimeModal from '../components/modals/order-time-modal';
import { Link, useLocation } from 'react-router-dom';
import { totalPrice } from '../utils/order-actions';
import { SubmitHandler, useForm } from 'react-hook-form';
import IDelivery from '../interfaces/IDelivery';
import { ActionButton } from '../utils/action-button';

type Inputs = {
    street: string,
    houseNumber: string,
    zipCode: string,
    place: string,
    remarks: string,
    fullName: string,
    email: string,
    phone: string,
    company: string,
};

export default function PaymentPage() {
    const [cart, setCart] = useState([]);
    const [openTime, setOpenTime] = React.useState(false);
    const [openMethod, setOpenMethod] = React.useState(false);

    const [timeslot, setTimeslot] = React.useState<Date>(new Date());
    const [asap, setAsap] = React.useState(true);

    const [method, setMethod] = React.useState('iDeal');
    const location = useLocation();

    const onSubmit: SubmitHandler<Inputs> = data => {
        console.log(data, timeslot, method, totalPrice(cart, deliveryOptions).toFixed(2))
        console.log(errors);
    };
    const {register, handleSubmit, watch, formState: {errors}} = useForm<Inputs>();
    console.log(watch('street'))

    //TODO get normal data instead of this
    const deliveryOptions: IDelivery = {
        amountMin: 0, durationMax: 0, durationMin: 0, isOpen: false, times: [],
        price: 3.95
    }

    const handleClickOpenOrderTime = () => {
        setOpenTime(true);
    };

    const handleClickOpenPaymentMethod = () => {
        setOpenMethod(true);
    };

    const handleCloseTime = (value: any) => {
        console.log('value', value)
        if (value?.$d) {
            setTimeslot(value.$d as Date);
            setAsap(false);
        } else {
            setAsap(true);
        }

        setOpenTime(false);
    };

    const handleClosePayment = () => {
        setOpenMethod(false);
    };


    useEffect(() => {
        setCart(location.state?.cartItems);
        // @ts-ignore
        // const savedItems = JSON.parse(localStorage.getItem('savedOrder'));
        // if (savedItems) {
        //     setCart(savedItems);
        // }
    }, [cart]);

    return (
        <div>
            <div className="flex w-full h-full bg-gray-50">
                <div className="relative w-full min-w-0">
                    <div className="sticky md:static top-0 z-40 md:z-0">
                        <Header/>
                    </div>
                    <div className="payment-page-layout">
                        <h1 className="page-title pb-8">Afrekenen</h1>
                        <h3 className="text-lg font-semibold">📍 Bezorggegevens </h3>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="payment-box">
                                <div className="md:flex-1 md:pr-2 pb-4 md:pb-0">
                                    <TextField {...register('street', {required: true})}
                                               error={errors.street?.message === ''}
                                               className="w-full"
                                               variant="outlined"
                                               label="Straat"
                                               type="text"
                                               id="street"/>
                                    <div
                                        className="error-message-form">{errors.street && 'Straatnaam is verplicht'}</div>
                                </div>
                                <div className="md:flex-1 md:pl-2">
                                    <TextField {...register('houseNumber', {required: true})}
                                               error={errors.houseNumber?.message === ''}
                                               className="w-full"
                                               variant="outlined"
                                               label="Huisnummer"
                                               type="text"
                                               id="house-number"/>
                                    <div
                                        className="error-message-form">{errors.houseNumber && 'Huisnummer is verplicht'}</div>
                                </div>
                            </div>

                            <div className="payment-box">
                                <div className="md:flex-1 md:pr-2 pb-4 md:pb-0">
                                    <TextField {...register('zipCode', {required: true})}
                                               error={errors.zipCode?.message === ''}
                                               className="w-full" variant="outlined" label="Postcode" type="text"
                                               id="zipcode"/>
                                    <div
                                        className="error-message-form">{errors.zipCode && 'Postcode is verplicht'}</div>
                                </div>
                                <div className="md:flex-1 md:pl-2">
                                    <TextField {...register('place', {required: true})}
                                               error={errors.place?.message === ''}
                                               className="w-full" variant="outlined" label="Woonplaats" type="text"
                                               id="place"/>
                                    <div
                                        className="error-message-form">{errors.place && 'Woonplaats is verplicht'}</div>
                                </div>
                            </div>

                            <div className="payment-box">
                                <div className="md:w-full pb-8">
                                    <TextField {...register('remarks')}
                                               className="w-full"
                                               variant="outlined"
                                               label="Opmerking toevoegen (optioneel)"
                                               type="text"
                                               id="remark"/>
                                </div>
                            </div>

                            <hr className="pb-8"/>

                            <h3 className="text-lg font-semibold">👤 Persoonsgegevens</h3>

                            <div className="payment-box">
                                <div className="md:flex-1 md:pr-2 pb-4 md:pb-0">
                                    <TextField {...register('fullName', {required: true})}
                                               error={errors.fullName?.message === ''}
                                               className="w-full" variant="outlined" label="Volledige naam"
                                               type="text"
                                               id="full-name"
                                    />
                                    <div className="error-message-form">{errors.fullName && 'Naam is verplicht'}</div>
                                </div>
                                <div className="md:flex-1 md:pl-2">
                                    <TextField {...register('email', {required: true})}
                                               error={errors.email?.message === ''}
                                               className="w-full" variant="outlined" label="E-mailadres" type="email"
                                               id="email"/>
                                    <div
                                        className="error-message-form">{errors.email && 'E-mailadres is verplicht'}</div>
                                </div>
                            </div>

                            <div className="payment-box">
                                <div className="md:flex-1 md:pr-2 pb-4 md:pb-0">
                                    <TextField {...register('phone', {required: true})}
                                               error={errors.phone?.message === ''}
                                               className="w-full" variant="outlined" label="Telefoonnummer" type="text"
                                               id="phone"/>
                                    <div
                                        className="error-message-form">{errors.phone && 'Telefoonnummer is verplicht'}</div>
                                </div>
                                <div className="md:flex-1 md:pl-2 pb-8">
                                    <TextField {...register('company')}
                                               className="w-full" variant="outlined" label="Bedrijfsnaam (optioneel)"
                                               type="text"
                                               id="company"/>
                                </div>
                            </div>

                            <hr className="pb-8"/>

                            <button onClick={handleClickOpenOrderTime} className="payment-action-box">
                                <h3 className="text-lg">⏱ Bezorgtijdstip️</h3>
                                {/*TODO calculate est time by distracting timeslot time with current time*/}
                                <div className="py-2 text-gray-500">
                                    {asap ?
                                        <>
                                            Verwacht tijdstip van aankomst:
                                            <span
                                                className="text-primary-500"> 20-45 min.</span>
                                        </>
                                        :
                                        <>
                                            {timeslot.getHours()}:{(timeslot.getMinutes()<10?'0':'') + timeslot.getMinutes()}
                                        </>
                                    }

                                </div>
                            </button>

                            {
                                openTime ?
                                    <OrderTimeModal
                                        open={openTime}
                                        onClose={handleCloseTime}/>
                                    : null
                            }

                            <button onClick={handleClickOpenPaymentMethod} className="payment-action-box mt-4 mb-8">
                                <h3 className="text-lg">💳 Kies betaalmethode</h3>
                                <div className="py-2 text-gray-500">{method}</div>
                            </button>

                            <PaymentMethodModal
                                open={openMethod}
                                onClose={handleClosePayment}
                                method={method}
                                setMethod={setMethod}/>

                            <hr className="pb-8"/>

                            <div className="py-2">
                                <div className="payment-disclaimer">Door op BESTEL EN BETAAL MET {method} te klikken ga
                                    je
                                    akkoord met de inhoud van het winkelmandje, de door jou ingevulde gegevens, ons
                                    privacy
                                    statement en onze voorwaarden. Er geldt geen herroepingsrecht.
                                </div>
                                <ActionButton
                                    variant="contained"
                                    type="submit"
                                    className="pay-button"
                                    color="secondary">
                                    Betaal met {method} en bestel
                                    (€{totalPrice(cart, deliveryOptions).toFixed(2).replace('.', ',')})
                                </ActionButton>
                                {/*<button className="pay-button">*/}
                                {/*    Betaal met {method} en bestel*/}
                                {/*    (€{totalPrice(cart, deliveryOptions).toFixed(2).replace('.', ',')})*/}
                                {/*</button>*/}
                            </div>
                        </form>
                    </div>
                    <Footer/>

                </div>
                <Sidebar deliveryOptions={deliveryOptions} totalPrice={totalPrice(cart, deliveryOptions)}
                         cartItems={cart}/>

            </div>
        </div>
    )
}